import { Component } from '@angular/core';
import { BaseDestroyable } from '@core/base-destroyable';
import { TranslateService } from '@ngx-translate/core';
import { InvitationsService } from '@services/invitations/invitations.service';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent extends BaseDestroyable {
  constructor(
    private translateSerice: TranslateService,
    private invitationService: InvitationsService
  ) {
    super();
    this.invitationService
      .getImsFFStatus()
      .pipe(takeUntil(this.componentAlive$))
      .subscribe();
    this.translateSerice.setDefaultLang('en-US');
  }
}
